module.exports = __webpack_public_path__ + "img/emulsifiers.bcddbdb.svg";